var _mask, _mask2, _path, _use, _path2, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-272.059 0 1544.118 1000",
    style: {
      cursor: "pointer"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    x: 104.454,
    y: 104.007,
    width: 791.092,
    height: 791.986,
    maskUnits: "userSpaceOnUse",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.413 139.966h719.174v720.068H140.413z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#fff",
    stroke: "#fff"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    x: 311.485,
    y: 347.512,
    width: 377.03,
    height: 304.976,
    maskUnits: "userSpaceOnUse",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.348 361.375h349.305v277.251H325.348z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "#fff",
    stroke: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M799.656 500a299.656 299.656 0 1 0-599.312 0 299.656 299.656 0 1 0 599.312 0Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 25,
    id: "a"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    strokeWidth: 0,
    id: "b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "none",
    strokeWidth: 1,
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M-382.4 292.1c-1.9 2-4.3 3.4-7.2 4-4.7.9-9.3-.7-12.3-3.9-.6-.6-1.1-1.2-1.5-1.9l15.3-12.8-16.8 9.6c-.2-.5-.3-1-.4-1.6-1.1-5.5 1.4-10.9 5.7-13.8.5-.3 1-.6 1.6-.9.3-.1.6-.3 1-.4.8-.3 1.5-.5 2.4-.7.5-.1.9-.1 1.4-.2 1.6-.5 4.5-1 9.6-1 10 0 13.5-1.5 14.7-3.1 1-1.4-5.6 20.2-13.5 26.7z",
    style: {
      strokeMiterlimit: 10
    },
    transform: "translate(3546.65 -1700.79) scale(7.832)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    style: {
      strokeMiterlimit: 10
    },
    d: "m-409.3 296.7 15.1-12",
    transform: "translate(3546.65 -1700.79) scale(7.832)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-272.059 0h1544.118v1000H-272.059z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#65a765",
    d: "M140.413 139.966h719.174v720.068H140.413z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "M325.348 361.375h349.305v277.251H325.348z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.f3e305386d53d73fa7c0e7601095d99f.svg";
export { ForwardRef as ReactComponent };